import { usePlay } from "@/providers/play-provider";
import { Button } from "@/components/ui/button";
import { MoveLeft } from "lucide-react";
import { getGameTypeLabel } from "@/pages/subs/play/common/game-registry";
import { RoomStatus } from "./room-status";
import { showMessageBox } from "@/components/blocks/message-box";

export const RoomHeader = () => {
  const { currentRoom, leaveGameRoom } = usePlay();

  const handleLeaveRoom = async () => {
    const result = await showMessageBox({
      type: "Confirm_Alert",
      title: "게임방 나가기",
      description: "정말로 게임방을 나가시겠습니까?",
    });

    if (result === "Yes") {
      leaveGameRoom();
    }
  };

  if (!currentRoom) {
    return null;
  }

  return (
    <div className="flex justify-between items-center p-4 border-b bg-muted">
      <div>
        <h1 className="text-xl font-bold">
          {currentRoom.roomTitle ||
            `🎮 ${getGameTypeLabel(currentRoom.gameType)}`}
        </h1>
        <div className="flex items-center gap-2 mt-1">
          <RoomStatus status={currentRoom.status} />
          <span className="text-sm text-muted-foreground">
            온라인 멀티플레이
          </span>
        </div>
      </div>
      <Button variant="outline" onClick={handleLeaveRoom}>
        <MoveLeft className="w-4 h-4 mr-2" />
        나가기
      </Button>
    </div>
  );
};
